// extracted by mini-css-extract-plugin
export var bounce = "_ob-1";
export var generatingText = "_ob-6";
export var lightning = "_ob-4";
export var popup = "_ob-5";
export var progressBar = "_ob-7";
export var progressFill = "_ob-8";
export var progressShimmer = "_ob-9";
export var progressText = "_ob-a";
export var shimmer = "_ob-3";
export var uploadIcon = "_ob-0";
export var uploadingText = "_ob-2";